import uuid from '@/script/uuid.mjs'
import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useCommonNode from '../_COMMON/useCommonNode.jsx'
import meta from './metaScene.mjs'

export default () => {
    const CommonNode = useCommonNode()

    return extendNode(CommonNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(CAT|FOPR)$/.test(type)
        },

        getStyle(map, node) {
            return {
                ...CommonNode.getStyle.call(this, map, node),
                borderColor: Color.GOLD,
                shape: 'BreakangleRectangle',
            }
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'FOPR'},
            ]
        },

        onPush(map, node, type, data) {
            let {sceneNo} = node.data

            if (! sceneNo) {
                sceneNo = uuid()
                node.data = {...node.data, sceneNo}
            }

            CommonNode.onPush.call(this, map, node, type, data)
        },

        _fixChild(map, node, child) {
            const {bizNodeType} = child.data

            if ('COPR' === bizNodeType) {
                map.BizNode.FOPR.castFrom(map, child)
                return true
            }
            else {
                return CommonNode._fixChild.call(this, map, node, child)
            }
        },
    })
}
